<template>
    <div class="business">
        <Header></Header>
        <div class="business_container business_container_bg1">
            <div class="main_content">
                <div class="business_title">餐饮外卖行业解决方案</div>
                <div class="business-bg1-box">
                    <div class="business-bg1-box-title">行业背景：</div>
                    <div class="business-bg1-box-text">
                        随着数字经济的深入发展和消费者生活习惯的改变，餐饮外卖行业迎来了爆发式增长。如今，外卖已成为餐饮消费的重要组成部分，订单量持续攀升，尤其是在午晚高峰、节假日等时段，订单集中爆发，对餐饮企业的订单处理效率、出餐速度和服务质量提出了极高要求。热敏打印机作为餐饮外卖订单信息传递的核心设备，其打印速度、稳定性、联网能力以及与外卖平台的兼容性，直接关系到订单流转效率、出餐准确率和客户满意度，是支撑餐饮外卖行业高效运营的关键基础设施。

                        从消费者下单到餐品送达，热敏打印的订单小票贯穿始终，承载着菜品信息、备注要求、配送地址、取餐编号等关键数据。一套高效可靠的热敏打印解决方案，能够帮助餐饮企业减少订单漏单、错单问题，缩短出餐时间，提升外卖服务体验，在激烈的市场竞争中占据优势。
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_write">
            <div class="main_content">
                <div class="business-tabs">
                    <div class="business-tab" v-for="(tab, index) in tabList" :key="tab.title + index"
                         :class="{active: activeTabIndex === index}" @click="activeTabIndex = index">
                        <img v-if="index === 0" src="../images/icon1.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon2.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon3.png" alt="icon">
                        {{ tab.tabName }}
                    </div>
                </div>
                <div class="business_title">
                    {{ tabList[activeTabIndex].title }}
                </div>
                <div class="business_subtitle"> {{ tabList[activeTabIndex].subtitle }}</div>
                <div class="business-block" v-if="tabList[activeTabIndex].beds.length === 4">
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item" v-for="(bed, index) in tabList[activeTabIndex].beds"
                         :key="bed.title+index">
                        <div class="business-block-item-title">{{ bed.title }}</div>
                        <div class="business-block-item-content">
                            <div class="business-block-item-text">{{ bed.text }}</div>
                            <img v-if="index === 0" class="business-block-item-img" src="../images/icon4.png"
                                 alt="img"/>
                            <img v-else-if="index === 1" class="business-block-item-img" src="../images/icon5.png"
                                 alt="img"/>
                            <img v-else-if="index === 2" class="business-block-item-img" src="../images/icon6.png"
                                 alt="img"/>
                            <img v-else-if="index === 3" class="business-block-item-img" src="../images/icon7.png"
                                 alt="img"/>
                        </div>
                    </div>
                </div>
                <div class="business-block2" v-else>
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item" v-for="(bed, index) in tabList[activeTabIndex].beds"
                         :key="bed.title+index">
                        <div class="business-block-item-title">{{ bed.title }}</div>
                        <div class="business-block-item-text">{{ bed.text }}</div>
                        <img v-if="index===0" class="business-block-item-img" src="../images/icon4.png" alt="img"/>
                        <img v-else-if="index===1" class="business-block-item-img" src="../images/icon5.png" alt="img"/>
                        <img v-else-if="index===2" class="business-block-item-img" src="../images/icon6.png" alt="img"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">解决方案</div>
                <div class="business_subtitle">{{ tabList[activeTabIndex].solution }}</div>
                <template v-if="activeTabIndex ===0">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/DP358&DP458.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">DP358</span> 工业级热敏票据自动切刀打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                自动接单，自动打印
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：180mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：58mm<br/>
                                接口：usb、WiFi<br/>
                                日均打印量：1000-50000单<br/>
                                适用场景：连锁中央厨房、大型配餐中心等高强度打印场景。
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                快麦云
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持多平台外卖订单自动抓取，按规则分配至指定打印机；实时监控各打印机工作状态和订单打印进度；提供订单数据统计报表功能，助力运营决策。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="./images/1.png" alt="printer">
                    </div>
                </template>
                <template v-else-if="activeTabIndex === 1">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/DP158.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">DP158</span> 系列商用热敏打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                自动接单，自动打印
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：120mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：58mm<br/>
                                接口：usb 、蓝牙、WiFi<br/>
                                日均打印量：500-2000单<br/>
                                适用场景：中小型餐饮门店后厨、小吃店等场景
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                快麦云
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持自动抓取美团、饿了么等平台外卖订单，智能合并重复订单；提供订单备注放大打印功能，便于厨师查看；支持堂食、外卖订单分区打印。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="./images/2.png" alt="printer">
                    </div>
                </template>
                <template v-else-if="activeTabIndex === 2">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/DP158.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">DP158</span> 系列商用热敏打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                自动接单，自动打印
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：120mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：58mm<br/>
                                接口：WiFi、usb<br/>
                                日均打印量：300-1000单<br/>
                                适用场景：外卖自提点、智能取餐柜、写字楼取餐点等场景
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                快麦云
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持自动接收外卖平台到店取餐订单，生成带二维码的取餐小票；与取餐柜系统对接，实时生成打印取餐码；提供取餐记录查询功能，便于核对餐品领取情况。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="./images/3.png" alt="printer">
                    </div>
                </template>
            </div>
        </div>
        <div class="business_container business_container_white">
            <div class="main_content">
                <div class="business_title">方案优势</div>
                <div class="business-good">
                    <div class="business-good-item" v-for="(good, index) in tabList[activeTabIndex].goods"
                         :key="good.title + index">
                        <img v-if="index === 0" src="../images/icon8.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon9.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon10.png" alt="icon">
                        <img v-else-if="index === 3" src="../images/icon11.png" alt="icon">
                        <div class="business-good-item-title">{{ good.title }}</div>
                        <div class="business-good-item-text">{{ good.text }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">场景典型客户案例</div>
                <div class="business-collaborative">
                    <template v-if="activeTabIndex === 0">
                        某连锁快餐品牌中央厨房引入工业级高速热敏打印机和快麦云软件后，订单打印效率提升了 2
                        倍，高峰时段订单堆积问题彻底解决，配餐出错率降低了 70%，通过数据统计优化食材采购，食材浪费减少了
                        15%。
                    </template>
                    <template v-else-if="activeTabIndex === 1">
                        某城区连锁麻辣烫门店引入快麦 DP158 系列打印机和快麦云软件后，后厨打印机故障率降低了
                        80%，多平台订单处理时间缩短了 50%，外卖订单平均出餐时间从 15 分钟减少至 8 分钟，客户差评率下降了
                        40%。
                    </template>
                    <template v-else-if="activeTabIndex === 2">
                        某写字楼外卖自提点引入快麦无线热敏打印机和番茄打印管家取餐管理模块后，用户平均取餐时间从 3 分钟缩短至
                        1 分钟，错拿餐品事件减少了 90%，取餐柜餐品存柜成功率提升至 99%，用户取餐满意度提高了 60%。
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../Header.vue';

export default {
    name: "CYWM",
    components: {Header},
    data() {
        return {
            activeTabIndex: 0,
            tabList: [
                {
                    tabName: '连锁餐饮中央厨房',
                    title: '连锁餐饮中央厨房',
                    subtitle: '连锁餐饮中央厨房承担着多门店的食材加工、配餐打包任务，日均处理数百至上千份外卖订单。订单需按门店、菜品类别进行分类打印，同步传递至各加工环节，确保配餐效率和准确性。',
                    solution: '部署快麦云打印机和番茄打印管家软件，构建中央厨房订单智能打印管理系统。',
                    beds: [
                        {
                            title: '订单集中打印拥堵',
                            text: '午晚高峰订单量激增，传统打印机打印速度慢，容易出现订单堆积、漏打问题，影响配餐进度。'
                        },
                        {
                            title: '多环节订单同步难',
                            text: '中央厨房加工、打包、配送等环节需同步获取订单信息，传统打印方式难以实现多设备协同打印，易导致信息传递滞后。'
                        },
                        {
                            title: '订单数据管理混乱',
                            text: '缺乏统一的订单打印管理系统，订单历史记录查询困难，无法进行数据统计分析，不利于运营优化。'
                        },
                    ],
                    goods: [
                        {
                            title: '高速打印应对订单高峰',
                            text: '快麦高速热敏云打印机打印速度可达 180mm/s，能够快速处理高峰时段的集中订单，避免订单堆积，保障配餐节奏。'
                        },
                        {
                            title: '多设备协同同步打印',
                            text: '通过快麦云打印软件，可实现多台打印机按环节、按门店分区协同打印，订单信息实时同步至各加工环节，减少信息传递时间。'
                        },
                        {
                            title: '数据化管理优化运营',
                            text: '软件支持订单打印记录自动存储、查询，可统计分析订单量、菜品销量等数据，为中央厨房的食材采购、人员调度提供数据支持。'
                        },
                    ]
                },
                {
                    tabName: '中小型餐饮门店后厨',
                    title: '中小型餐饮门店后厨',
                    subtitle: '中小型餐饮门店后厨空间有限，日均处理数十至数百份外卖订单，操作人员为厨师和后厨工作人员，对设备的易用性和稳定性要求较高。需快速打印外卖订单小票，明确菜品名称、数量、备注等信息，指导厨师高效备餐。',
                    solution: '部署快麦商用热敏打印机和快麦云软件，打造门店后厨高效订单打印解决方案。',
                    beds: [
                        {
                            title: '设备易故障影响出餐',
                            text: '后厨环境油烟大、湿度高，传统打印机易出现卡纸、打印模糊等故障，导致订单信息不清，影响出餐效率。'
                        },
                        {
                            title: '多平台订单切换繁琐',
                            text: '门店通常入驻多个外卖平台，不同平台订单格式不同，需频繁切换打印设置，易出现漏单、错打问题。'
                        },
                        {
                            title: '订单优先级难区分',
                            text: '高峰时段堂食订单与外卖订单混杂，传统打印方式无法区分订单优先级，容易导致外卖订单出餐延迟，引发客户投诉。'
                        },
                    ],
                    goods: [
                        {
                            title: '耐用抗造适应后厨环境',
                            text: '快麦商用热敏打印机采用防油烟、抗潮湿设计，机身耐用性强，在复杂后厨环境中故障率低，保障订单持续稳定打印。'
                        },
                        {
                            title: '多平台订单一键整合',
                            text: '配合快麦云软件，可自动整合各外卖平台订单，统一格式打印，无需频繁切换设置，减少操作繁琐度和出错率。'
                        },
                        {
                            title: '订单优先级智能区分',
                            text: '软件支持设置订单优先级，外卖订单可标记特殊标识并优先打印，帮助后厨合理安排备餐顺序，缩短外卖出餐时间。'
                        },
                    ]
                },
                {
                    tabName: '外卖自提点 / 取餐柜配套',
                    title: '外卖自提点 / 取餐柜配套',
                    subtitle: '外卖自提点和智能取餐柜是外卖配送的末端节点，负责暂存外卖餐品并通知用户取餐。需为到店取餐用户打印取餐小票，或为取餐柜生成取餐码标签，实现餐品快速核对和领取。',
                    solution: '部署快麦无线热敏打印机和番茄打印管家取餐管理，构建外卖末端取餐高效打印系统。',
                    beds: [
                        {
                            title: '人工核对效率低易出错',
                            text: '自提点餐品数量多，人工核对用户信息耗时久，易出现错拿、漏拿问题，影响取餐体验。'
                        },
                        {
                            title: '取餐码生成打印不及时',
                            text: '智能取餐柜需要实时生成并打印取餐码标签，传统打印机响应慢，可能导致餐品无法及时存入柜中。'
                        },
                        {
                            title: '设备联网稳定性差',
                            text: '自提点和取餐柜多位于户外或公共场所，网络环境复杂，打印机联网不稳定易导致打印失败。'
                        },
                    ],
                    goods: [
                        {
                            title: '快速打印取餐凭证',
                            text: '打印机响应速度快，可瞬间生成并打印取餐小票或取餐码标签，用户凭票快速取餐，减少人工核对时间。'
                        },
                        {
                            title: '稳定联网保障实时打印',
                            text: '支持 WiFi、usb 等多种无线连接方式，在复杂网络环境下仍能保持稳定连接，确保取餐码实时生成打印，不影响餐品存柜。'
                        },
                        {
                            title: '数据同步便于管理',
                            text: '与外卖平台和取餐柜系统实时数据同步，记录餐品存入、取出时间，便于运营方进行订单追踪和管理。'
                        },
                    ]
                },
            ]
        }
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../business.scss";
</style>
